import type { InfoCardProps } from "@components/InfoCardProps.js";
import brackets from "@core/assets/icons/brackets.svg?raw";
import type { Tenant } from "@core/schema/Tenant.js";
import { getWebAppsPath } from "@core/schema/paths/getWebAppsPath.js";

export function getTypesOfWebsites(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Firemní weby a prezentace",
			desc: "Poutavý a uživatelsky přívětivý web je základem každého úspěšného podnikání. Dodáme vám ho „na klíč.“",
			iconName: brackets,
			show: true,
		},
		{
			title: "E-commerce řešení",
			desc: "Navrhneme a naprogramuje pro vás stabilní a rychlý e-shop, včetně potřebných funkcionalit (např. platební brána nebo integrace s CRM a ERP).",
			iconName: brackets,
			show: true,
		},
		{
			title: "Portály",
			desc: "Máme zkušenosti také s vývojem zákaznických, vzdělávacích nebo komunitních a e-commerce portálů.",
			iconName: brackets,
			show: true,
		},
		{
			title: "Mikrostránky",
			desc: "Potřebujete krátce odprezentovat produkt, službu nebo událost? Naši profíci vám dodají mikrostránku na míru.",
			iconName: brackets,
			show: true,
		},
		{
			title: "Rezervační systémy",
			desc: "Skoncujte s nefunkčním procesem objednávek a rezervací od klientů. Na zakázku pro vás naprogramujeme spolehlivý rezervační systém.",
			iconName: brackets,
			show: true,
		},
		{
			title: "Webové aplikace",
			desc: `Vyvíjíme [${getWebAppsPath(tenant)}][[webové aplikace]], které rostou s vaším podnikáním. Škálovatelná a bezpečná řešení s možností integrace CRM, ERP nebo platebních bran.`,
			iconName: brackets,
			show: true,
		},
		{
			title: "Weby pro SaaS",
			desc: "Poskytujete služby formou Software as a service (software jako služba)? Vyvineme vám pro tyto účely unikátní webové stránky.",
			iconName: brackets,
			show: true,
		},
		{
			title: "Osobní weby a blogy",
			desc: "Webové vizitky jednotlivců a blogy rozhodně nevyšly z módy. Nespoléhejte se na krabicové řešení a nechte si udělat stránky na míru.",
			iconName: brackets,
			show: true,
		},
	];
}
